/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditGroupHasTransferApiRequest } from '../../models/hotel-edit-group-has-transfer-api-request';

export interface ApiHotelManageEditGroupTransferPost$Params {
      body: HotelEditGroupHasTransferApiRequest
}

export function apiHotelManageEditGroupTransferPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditGroupTransferPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditGroupTransferPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditGroupTransferPost.PATH = '/api/hotel/manage/edit/group/transfer';
